import { forwardRef } from "react";
import packageJson from "../../../package.json";
import { useVersionInfo } from "../../api/query-hooks";
import { VersionInfo as VersionInfoData } from "../../api/types/common";

// Release builds pass the semantic-release version via NEXT_PUBLIC_APP_VERSION,
// because the image is built from the commit before package.json gets bumped.
export const frontendVersion =
  process.env.NEXT_PUBLIC_APP_VERSION || packageJson.version;

export const VersionInfo = forwardRef<HTMLDivElement>(
  function VersionInfo(_props, ref) {
    const { data, isLoading, isRefetching } = useVersionInfo();
    const versionInfo = data?.data as VersionInfoData | undefined;
    const commit =
      versionInfo?.commit && versionInfo.commit !== "none"
        ? versionInfo.commit.slice(0, 8)
        : undefined;

    if (isLoading || isRefetching) {
      return null;
    }

    return (
      <div
        ref={ref}
        className="block border-0 border-b border-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900"
      >
        <div>
          Frontend: <b className="text-xs">{frontendVersion}</b>
        </div>
        <div>
          Backend: <b className="text-xs">{versionInfo?.backend || "NA"}</b>
          {commit && (
            <span
              className="ml-1 text-xs text-gray-500"
              title={versionInfo?.buildDate}
            >
              ({commit})
            </span>
          )}
        </div>
        {versionInfo?.chart && (
          <div>
            Chart: <b className="text-xs">{versionInfo.chart}</b>
          </div>
        )}
      </div>
    );
  }
);
